import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectEntities } from 'services/entities/selectors';
import { AppState } from 'services/types';
import { OwnProps } from './index';

const selectOptions = (state: AppState, props: OwnProps): any => props.options;

const selectEntitiesWithMissingFertilizerSettings = createDeepEqualSelector(
    selectEntities,
    selectOptions,
    (entities, options) => {
        const filteredEntities: any = [];

        options.forEach((entityOption: any) => {
            if (entities && entities[entityOption.value]) {
                const { totalArea } = entities[entityOption.value];

                if (!totalArea) {
                    filteredEntities.push(entityOption.text);
                }
            }
        });

        return filteredEntities;
    }
);

const makeSelectEntitiesWithMissingFertilizerSettings =
    (): typeof selectEntitiesWithMissingFertilizerSettings =>
        selectEntitiesWithMissingFertilizerSettings;

export { makeSelectEntitiesWithMissingFertilizerSettings };
